(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxSearchQueryConditionFloat', {
		bindings: {
			condition: '<',
			operators: '<',
		},
		controller: MxSearchQueryConditionFloatCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-search-query-condition/by-type/mx-search-query-condition-float.html',
	});

	MxSearchQueryConditionFloatCtrl.$inject = ['$scope'];

	function MxSearchQueryConditionFloatCtrl($scope) {
		const vm = this;

		vm.$onInit = function () {
			if (vm.condition) {
				if (!Array.isArray(vm.condition.value) || !vm.condition.value.length) {
					vm.condition.value = [''];
				}
			}
		};

		$scope.$watchCollection('vm.condition.value', updateConditionValidity);
		return vm;

		function updateConditionValidity() {
			const withoutParamsMode = vm.condition.operator === vm.operators.IsNotSet.value || vm.condition.operator === vm.operators.IsSet.value;
			if (vm.condition.operator === vm.operators.Between.value) {
				vm.condition.__valid = Array.isArray(vm.condition.value) && !isNaN(vm.condition.value[0]) && !isNaN(vm.condition.value[1]);
			} else {
				vm.condition.__valid = Array.isArray(vm.condition.value) && !isNaN(vm.condition.value[0]);
			}
			vm.condition.__valid = vm.condition.__valid || withoutParamsMode;
		}
	}
})();
